(function(window) {
    'use strict'

    const internal = window.RTAnalyticsInternal
    const trackedTickets = new Map()

    window.RT = window.RT || {}

    function createFailedTicket() {
        return Object.freeze({
            eventId: null,
            persisted: Promise.resolve(false),
            attempted: Promise.resolve([])
        })
    }

    function track(name, payload, options) {
        const eventOptions = options || {}
        if (eventOptions.dedupeKey && trackedTickets.has(eventOptions.dedupeKey)) {
            return trackedTickets.get(eventOptions.dedupeKey)
        }

        const definition = internal.router.getEventDefinition(name)
        if (!definition) {
            return createFailedTicket()
        }

        const event = internal.eventFactory.createEvent(
            name,
            payload || {},
            eventOptions,
            definition.version
        )
        const deliveries = internal.router.resolveDeliveries(event)
        if (!deliveries.length) {
            return createFailedTicket()
        }

        const persistence = internal.storage.persistEnvelope(event, deliveries)
        const persisted = persistence.then(function(result) {
            return result.stored
        }).catch(function() {
            return false
        })
        const attempted = persistence.then(function(result) {
            if (result.stored) {
                return internal.outbox.flushEvent(event.id)
            }

            return internal.outbox.attemptDirect(deliveries)
        }).catch(function() {
            return []
        })

        const ticket = Object.freeze({
            eventId: event.id,
            persisted: persisted,
            attempted: attempted
        })

        if (eventOptions.dedupeKey) {
            trackedTickets.set(eventOptions.dedupeKey, ticket)
        }

        return ticket
    }

    function registerProvider(name, provider) {
        const registered = internal.providers.register(name, provider)
        if (registered) {
            internal.outbox.flush()
        }

        return registered
    }

    window.RT.analytics = Object.freeze({
        track: track,
        flush: internal.outbox.flush,
        cleanup: internal.storage.cleanupExpired,
        defineEvent: internal.router.defineEvent,
        registerProvider: registerProvider
    })
})(window)
